var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Configuration',{attrs:{"project":_vm.vid,"embed":"","data-testid":"configuration-component"}})
}
var staticRenderFns = []

export { render, staticRenderFns }